module.exports = __webpack_public_path__ + "static/media/household-cleaning.958585f1.jpeg";